<script lang="ts">
	import type { Device, DeviceRawData } from "luxedo-data"
	import DeviceTableEntry from "./DeviceTableEntry.svelte"

	interface Props {
		devices: Array<DeviceRawData | Device>;
	}

	let { devices }: Props = $props();
</script>

<table>
	<thead>
		<tr>
			<th> ID </th>
			<th> Name </th>
			<th> Last Status </th>
		</tr>
	</thead>
	<tbody>
		{#each devices as device}
			<DeviceTableEntry {device} />
		{/each}
	</tbody>
</table>

<style>
	table {
		margin-top: 1rem;
	}

	thead th:first-of-type {
		padding-left: 1rem;
	}
</style>
